import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    create_Quote,
    get_Quote_Data,
    get_Single_Package,
    get_Quote_Info,
    get_Quote_Template,
    get_Template_Content,
    last_Five_Quote,
    get_AllQuotes,
    delete_Quote,
    convert_Quote,
    get_Email_Template
} from '../../../Service/Quote/QuoteService'
const UserId = JSON.parse(localStorage.getItem("agent_id"));


export const createQuote = createAsyncThunk("create_quote", async (data) => {
    try { 
        const res = await create_Quote(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getQuoteData = createAsyncThunk("get_quote", async (data) => {
    try {
        const res = await get_Quote_Data(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getQuoteTemplate = createAsyncThunk("getQuoteTemplate", async (data) => {
    try { 
        const res = await get_Quote_Template(data);
        return await res;
    } catch (err) {
        return err;
    }
});

// Fetching All Email Template

export const getEmailTemplate = createAsyncThunk("getEmailTemplate", async (data) => {
    try { 
        const res = await get_Email_Template(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getTemplateContent = createAsyncThunk("gettemplatecontent", async (data) => {
    try { 
        const res = await get_Template_Content(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getQuoteInfo = createAsyncThunk("getQuoteInfo", async (data) => {
    try {
        const res = await get_Quote_Info(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getSinglePackage = createAsyncThunk("get_quote_ps", async (data) => {
    try {
        
        const res = await get_Single_Package(data);
        return await res;
    } catch (err) {
        return err;
    }
});


export const lastFiveQuote = createAsyncThunk("LastFiveQuotes", async (data) => {


    try {
        const res = await last_Five_Quote(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const deleteQuote = createAsyncThunk("deleteQuote", async (data) => {
    try {
        const res = await delete_Quote(data);
        return await res;
    } catch (err) {
        return
    }
});


export const convertQuote = createAsyncThunk("convertQuote", async (data) => {
    try {
        const res = await convert_Quote(data);
        return await res;
    } catch (err) {
        return err;
        }
});


export const getAllQuotes = createAsyncThunk("getAllQuotes", async (data) => {

    try {
        const res = await get_AllQuotes(data);
        return await res;
    } catch (err) {
        return err;
    }
});




const QuoteSlice = createSlice({
    name: "QuoteSlice",
    initialState: {
        isLoading: false,
        isError: false,
        createquote: [],
        getquotedata: [],
        getsinglepackage: [],

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createQuote.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(createQuote.fulfilled, (state, action) => {
                state.isLoading = false;
                state.createquote = action.payload;
            })
            .addCase(createQuote.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getQuoteData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getQuoteData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getquotedata = action.payload;
            })
            .addCase(getQuoteData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(getSinglePackage.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getSinglePackage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getsinglepackage = action.payload;
            })
            .addCase(getSinglePackage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

    },

});

export default QuoteSlice;
